import React, { useCallback, useMemo, useEffect } from 'react'

import { useIncidentsMap } from '../../incidents/hooks'
import { BASE_URL, ICONS } from '../../constants'

import ClusterLayer from './ClusterLayer'

const getIncidentSymbol = (isSelected, getCrimeCategory) => (incident) => {
  const size = '50px'
  let iconPath = `${BASE_URL}${ICONS.DIR}`
  let icon = ''

  if (!incident.agencyIds.includes('PD') && !incident.agencyIds.includes('FR')) {
    iconPath = `${BASE_URL}${isSelected ? ICONS.MUNICIPALITIES.ACTIVE.DIR : ICONS.MUNICIPALITIES.DIR
      }`
  } else {
    iconPath = `${BASE_URL}${isSelected ? ICONS.ACTIVE.DIR : ICONS.DIR}`
  }
  icon = getCrimeCategory(incident.crimeCategory).icon

  return {
    type: 'picture-marker',
    url: `${iconPath}${icon}`,
    width: size,
    height: size,
  }
}

const getIncidentGeometry = (incident) => ({
  type: 'point',
  x: incident.longitude,
  y: incident.latitude,
})

const getIncidentAttributes = (incident) => ({
  id: incident.incidentNumber,
})

const IncidentLayer = ({ map, view }) => {
  const [
    { incidents, categories, selected },
    { select, clear },
  ] = useIncidentsMap()

  const getIsSelected = useCallback(
    (graphic) =>
      selected.ids.length &&
      selected.ids[selected.current] === graphic.attributes.id,
    [selected]
  )

  const graphics = useMemo(() => {
    const incidentGraphics = incidents.map((incident) => {
      const isSelected =
        selected.ids.length &&
        selected.ids[selected.current] === incident.incidentNumber
      return {
        geometry: getIncidentGeometry(incident),
        symbol: getIncidentSymbol(isSelected, categories)(incident),
        attributes: getIncidentAttributes(incident),
      }
    })
    return incidentGraphics
  }, [incidents, selected, categories])

  const onSelect = useCallback(
    (graphics) => {
      if (
        !selected.ids.some((id) => graphics.some((g) => g.attributes.id === id))
      ) {
        select(graphics.map((g) => g.attributes.id))
      }
    },
    [select, selected]
  )

  // Zoom/pan on selection change
  useEffect(() => {
    if (selected.ids.length) {
      const incidentNumber = selected.ids[selected.current]
      const graphic = graphics.find((g) => g.attributes.id === incidentNumber)
      if (
        graphic &&
        graphic.geometry &&
        graphic.geometry.x &&
        graphic.geometry.y
      ) {
        const zoom = view.zoom > 15 ? view.zoom : 15
        view.goTo({
          center: [graphic.geometry.x, graphic.geometry.y],
          zoom,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, view]) // only update when selection changes

  return (
    <ClusterLayer
      id="IncidentLayer"
      map={map}
      view={view}
      graphics={graphics}
      getIsSelected={getIsSelected}
      onSelect={onSelect}
      onDeselect={clear}
    />
  )
}

export default IncidentLayer
